(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ut-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-filters')) {
  customElements.define('ut-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.section = this.closest('section[data-section-id]');
      this.nav = this.closest('ut-collection-navigation');
      this.grid = this.section?.querySelector('[data-products-grid]');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.opener = this.querySelector('[data-ut-filter-open]');
      if (!this.grid) return;
      this.opener.addEventListener('click', () => {
        this.syncSizes();
        this.oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
      }, {signal});
      this.querySelector('[data-ut-filter-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
      this.dialog.addEventListener('close', () => {document.body.style.overflow = this.oldOverflow || '';this.opener.setAttribute('aria-expanded','false');}, {signal});
      this.form.addEventListener('change', () => this.syncStockRequirement(), {signal});
      this.form.addEventListener('submit', event => {event.preventDefault();this.applyForm();}, {signal});
      this.querySelector('[data-ut-filter-clear]').addEventListener('click', () => {
        this.form.querySelectorAll('input').forEach(input => {if(input.type === 'checkbox') input.checked=false;else input.value='';});
        this.applyForm();
      }, {signal});
      this.grid.addEventListener('click', event => {
        const more = event.target.closest('[data-ut-size-more]');
        if(more) {event.preventDefault();this.showCards(this.visibleCards + 24);}
      }, {signal});
      window.addEventListener('popstate', () => this.update(new URL(location.href), false), {signal});
      this.syncSizes();
      this.updateBadge();
      if(new URL(location.href).searchParams.has('ut_ring_size')) this.update(new URL(location.href), false);
    }
    disconnectedCallback() {this.controller?.abort();this.request?.abort();this.controller=null;if(this.dialog?.open)document.body.style.overflow=this.oldOverflow||'';}
    syncSizes() {
      const sizes = new URL(location.href).searchParams.getAll('ut_ring_size');
      this.form.querySelectorAll('[name="ut_ring_size"]').forEach(input => input.checked=sizes.includes(input.value));
      const stock=this.form.querySelector('[data-ut-stock-only]');
      if(stock)stock.checked=new URL(location.href).searchParams.get('filter.v.availability')==='1'||sizes.length>0;
      this.syncStockRequirement();
    }
    syncStockRequirement() {
      const required=Boolean(this.form.querySelector('[name="ut_ring_size"]:checked'));
      const stock=this.form.querySelector('[data-ut-stock-only]');
      if(stock){if(required)stock.checked=true;stock.disabled=required;}
    }
    updateBadge() {
      const params = new URL(location.href).searchParams;
      let count=0;
      for(const [key,value] of params) if(value && (key.startsWith('filter.') || key==='ut_ring_size') && !key.startsWith('filter.v.price.')) count++;
      if(params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) count++;
      const badge=this.querySelector('[data-ut-filter-count]');badge.textContent=`(${count})`;badge.hidden=count===0;this.opener.dataset.active=String(count>0);
    }
    applyForm() {
      const url=new URL(location.href);
      for(const key of [...url.searchParams.keys()]) if(key.startsWith('filter.')||key==='ut_ring_size'||key==='page')url.searchParams.delete(key);
      for(const [key,value] of new FormData(this.form)) if(value!=='')url.searchParams.append(key,value);
      if(url.searchParams.has('ut_ring_size'))url.searchParams.set('filter.v.availability','1');
      const min=this.form.querySelector('[name="filter.v.price.gte"]');
      const max=this.form.querySelector('[name="filter.v.price.lte"]');
      if(min&&max&&min.value&&max.value&&Number(min.value)>Number(max.value)) {
        url.searchParams.set('filter.v.price.gte',max.value);url.searchParams.set('filter.v.price.lte',min.value);
      }
      this.update(url,true);
    }
    async fetchDocument(url,signal) {
      const response=await fetch(url.toString(),{signal});if(!response.ok)throw new Error('Filter request failed');
      return new DOMParser().parseFromString(await response.text(),'text/html');
    }
    async sizeCards(url,sizes,signal) {
      const endpoint=new URL(url);endpoint.searchParams.set('view','ut-size-results');endpoint.searchParams.set('page','1');endpoint.searchParams.delete('ut_ring_size');
      let doc=await this.fetchDocument(endpoint,signal);
      const pages=Number(doc.querySelector('[data-ut-size-pages]')?.dataset.utSizePages);
      if(!pages)throw new Error('Size results unavailable');
      const cards=[];
      const min=Number(url.searchParams.get('filter.v.price.gte')||0);
      const max=Number(url.searchParams.get('filter.v.price.lte')||Infinity);
      for(let page=1;page<=pages;page++) {
        if(page>1){endpoint.searchParams.set('page',String(page));doc=await this.fetchDocument(endpoint,signal);}
        for(const template of doc.querySelectorAll('template[data-ut-size-card]')) {
          const variants=JSON.parse(template.content.querySelector('[data-ut-size-variants]').textContent);
          const match=variants.find(v=>v.available&&sizes.includes(String(v.size).replace(/^US\s*/i,'').trim())&&v.price>=min&&v.price<=max);
          if(!match)continue;
          const card=template.content.querySelector('[data-product-grid-item]').cloneNode(true);
          card.querySelectorAll('a[href]').forEach(link=>{const target=new URL(link.getAttribute('href'),url);if(target.pathname.endsWith('/products/'+template.dataset.productHandle)){target.searchParams.set('variant',match.id);link.href=target.href;}});
          cards.push(card);
        }
      }
      return cards;
    }
    showCards(limit) {
      this.visibleCards=limit;
      this.grid.replaceChildren(...this.cards.slice(0,limit).map(card=>card.cloneNode(true)));
      if(!this.cards.length){const empty=document.createElement('p');empty.className='no-results';empty.textContent=this.dataset.empty;this.grid.append(empty);}
      if(limit<this.cards.length){const holder=document.createElement('div');holder.className='ut-size-load-more';const button=document.createElement('button');button.type='button';button.dataset.utSizeMore='';button.textContent=this.dataset.more;holder.append(button);this.grid.append(holder);}
    }
    async update(url,push) {
      this.request?.abort();this.request=new AbortController();const signal=this.request.signal;
      this.querySelector('[data-ut-filter-error]').hidden=true;
      this.querySelectorAll('.ut-filter-actions button').forEach(button=>button.disabled=true);
      this.querySelector('[data-ut-filter-loading]').hidden=false;this.grid.setAttribute('aria-busy','true');
      try {
        const sizes=url.searchParams.getAll('ut_ring_size');
        const [doc,cards]=await Promise.all([this.fetchDocument(url,signal),sizes.length?this.sizeCards(url,sizes,signal):Promise.resolve(null)]);
        if(signal.aborted)return;
        const nav=doc.querySelector('ut-collection-navigation');
        const grid=doc.querySelector('[data-products-grid]');
        const body=doc.querySelector('[data-ut-filter-body]');
        if(!nav||!grid||!body)throw new Error('Filter markup unavailable');
        if(push)history.pushState(null,'',url);
        if(cards){this.cards=cards;this.showCards(24);}else this.grid.innerHTML=grid.innerHTML;
        this.querySelector('[data-ut-filter-body]').innerHTML=body.innerHTML;
        const count=cards?cards.length:Number(nav.dataset.resultCount);
        this.nav.querySelector('.ut-collection-result-count').textContent=this.nav.dataset.countLabel.replace('[count]',count);
        this.syncSizes();this.updateBadge();
        this.dispatchEvent(new CustomEvent('ut:filters-updated',{bubbles:true}));
        if(this.dialog.open)this.dialog.close();
      } catch(error) {
        if(error.name!=='AbortError'){console.warn('Collection filter update failed:',error);const message=this.querySelector('[data-ut-filter-error]');message.textContent=this.dataset.error;message.hidden=false;if(!this.dialog.open){this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.opener.setAttribute('aria-expanded','true');}}
      } finally {
        if(!signal.aborted){this.querySelectorAll('.ut-filter-actions button').forEach(button=>button.disabled=false);this.querySelector('[data-ut-filter-loading]').hidden=true;this.grid.removeAttribute('aria-busy');}
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.addEventListener('ut:filters-updated', () => this.syncLinks());
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (/\/collections\/(necklaces|chains|bracelets|earrings)(?:\/|$)/.test(target.pathname) || /ut-category-(necklaces|bracelets|earrings)/.test(target.pathname)) target.searchParams.delete('ut_ring_size');
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-ring-guide')) {
  customElements.define('ut-ring-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        if (this.visibilityObserver) this.visibilityObserver.observe(this.closest('.product-modal'), {attributes:true, attributeFilter:['style','class']});
        return;
      }
      this.ready = true;
      const modal = this.closest('.product-modal');
      if (modal) {
      const syncVisibility = () => modal.setAttribute('aria-hidden', String(getComputedStyle(modal).display === 'none'));
      this.visibilityObserver = new MutationObserver(syncVisibility);
      this.visibilityObserver.observe(modal, {attributes:true, attributeFilter:['style','class']});
      syncVisibility();
      }
      this.rows = Array.from(this.querySelectorAll('[data-guide-row]'));
      this.system = this.querySelector('[data-guide-system]');
      this.value = this.querySelector('[data-guide-value]');
      this.measurement = this.querySelector('[data-guide-measurement]');
      this.result = this.querySelector('[data-guide-result]');
      this.error = this.querySelector('[data-guide-error]');
      this.apply = this.querySelector('[data-guide-apply]');
      this.system.addEventListener('change', () => this.setupSystem());
      this.value.addEventListener('change', () => this.convert());
      this.measurement.addEventListener('input', () => this.convert());
      this.apply.addEventListener('click', () => this.applySize());
      this.querySelectorAll('[data-guide-pick]').forEach(button => button.addEventListener('click', () => {
        this.system.value = 'us';
        this.setupSystem();
        this.value.value = button.dataset.guidePick;
        this.convert();
        this.querySelector('.ut-guide-scroll').scrollTo({top: 0, behavior: 'auto'});
      }));
      this.querySelectorAll('[data-guide-tab]').forEach((button, index, tabs) => {
        button.addEventListener('click', () => this.showTab(button.dataset.guideTab));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.showTab(tabs[next].dataset.guideTab);
          tabs[next].focus();
        });
      });
      this.querySelectorAll('[data-guide-measure-with]').forEach(button => button.addEventListener('click', () => {
        this.showTab('convert');
        this.system.value = button.dataset.guideMeasureWith;
        this.setupSystem();
        this.measurement.focus();
      }));
      this.setupSystem();
    }
    disconnectedCallback() { this.visibilityObserver?.disconnect(); }
    showTab(name) {
      this.querySelectorAll('[data-guide-tab]').forEach(tab => {
        const selected = tab.dataset.guideTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-guide-panel]').forEach(panel => panel.hidden = panel.dataset.guidePanel !== name);
      this.querySelector('.ut-guide-scroll').scrollTop = 0;
    }
    setupSystem() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      this.querySelector('[data-guide-input-label]').hidden = !measurementMode;
      this.querySelector('[data-guide-select-label]').hidden = measurementMode;
      this.result.hidden = true;
      this.error.hidden = true;
      this.measurement.value = '';
      this.rows.forEach(row => delete row.dataset.selected);
      this.value.replaceChildren(new Option(this.dataset.prompt, ''));
      const start = system === 'us' ? 5 : system === 'uk' ? 9.5 : 49;
      const end = system === 'us' ? 12 : system === 'uk' ? 23.5 : 67;
      const step = system === 'eu' ? 1 : .5;
      if (measurementMode) return;
      for (let value = start; value <= end; value += step) {
        const label = system === 'uk' ? String.fromCharCode(65 + Math.floor(value)) + (value % 1 ? '½' : '') : String(value);
        this.value.add(new Option(label, String(value)));
      }
    }
    convert() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      const raw = measurementMode ? this.measurement.value.trim().replace(',', '.') : this.value.value;
      this.error.hidden = true;
      this.result.hidden = true;
      this.rows.forEach(row => delete row.dataset.selected);
      if (!raw) return;
      const value = Number(raw);
      const key = system === 'uk' ? 'ukNumber' : system;
      const valid = /^\d+(\.\d+)?$/.test(raw) && Number.isFinite(value);
      if (!valid || value <= 0) return this.showError(this.dataset.invalid);
      const first = Number(this.rows[0].dataset[key]);
      const last = Number(this.rows[this.rows.length - 1].dataset[key]);
      if (value < first || value > last) return this.showError(this.dataset.outside);
      const row = this.rows.reduce((best, candidate) => Math.abs(Number(candidate.dataset[key]) - value) <= Math.abs(Number(best.dataset[key]) - value) ? candidate : best);
      const exact = Math.abs(Number(row.dataset[key]) - value) < .01;
      this.selectedRow = row;
      row.dataset.selected = 'true';
      this.querySelector('[data-guide-match]').textContent = exact ? this.dataset.exact : this.dataset.approx;
      this.querySelector('[data-guide-output]').textContent = 'US ' + row.dataset.us;
      this.querySelector('[data-guide-detail]').textContent = 'UK ' + row.dataset.uk + ' · EU ' + row.dataset.eu + ' · ' + row.dataset.diameter + ' mm';
      const available = row.dataset.available === 'true';
      const offered = row.dataset.offered === 'true';
      this.apply.disabled = !available || !offered;
      this.apply.textContent = !offered ? this.dataset.notOffered : !available ? this.dataset.soldOut : this.dataset.apply.replace('[size]', row.dataset.us);
      this.result.hidden = false;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    applySize() {
      if (!this.selectedRow || this.apply.disabled) return;
      const form = this.closest('form');
      if (!form) return;
      const size = this.selectedRow.dataset.us;
      const input = Array.from(form.querySelectorAll('[data-single-option-selector]')).find(el => el.dataset.index === this.dataset.optionIndex && el.value === size);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      this.closest('.product-modal').querySelector('.product-modal__close').click();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
